const log_details = {
    page_title: 'Chi tiết nhật ký kiểm tra',
    back_to_logs: 'Quay lại nhật ký kiểm tra',
    back_to: 'Quay lại {{name}}',
    success: 'Thành công',
    failed: 'Thất bại',
    event_key: 'Mã sự kiện',
    application: 'Ứng dụng',
    ip_address: 'Địa chỉ IP',
    user: 'Người dùng',
    log_id: 'ID nhật ký',
    time: 'Thời gian',
    user_agent: 'User agent',
    tab_details: 'Chi tiết',
    raw_data: 'Dữ liệu thô',
};
export default Object.freeze(log_details);
